import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingIndicatorService {
  readonly isLoading = signal(false);

  get showLoading() {
    return this.isLoading();
  }
}
